import { TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { getApplicationCopy } from "@/lib/application-copy";
import { closeModal } from "@/store/modal.store";
import type { ExamCategory } from "@/types/test-execution";

export function LeaveTabWarningModal({
	category,
}: {
	category?: ExamCategory | number;
}) {
	const copy = getApplicationCopy(category);
	return (
		<DialogContent className="max-w-md rounded-md p-8">
			<DialogHeader className="flex flex-row items-center gap-4 space-y-0">
				<div className="size-12 rounded-md bg-amber-100 flex items-center justify-center text-amber-600 shrink-0">
					<TriangleAlert size={24} />
				</div>
				<DialogTitle className="text-xl font-bold text-slate-900">
					Saída detectada
				</DialogTitle>
			</DialogHeader>
			<DialogDescription className="text-slate-500 text-base mt-4">
				{copy.leaveTabWarning}
			</DialogDescription>
			<div className="mt-8">
				<Button
					onClick={closeModal}
					className="w-full h-12 rounded-md bg-amber-600 hover:bg-amber-700 text-white font-bold"
				>
					Entendi
				</Button>
			</div>
		</DialogContent>
	);
}
